// extracted by mini-css-extract-plugin
export default {"main":"BaseSimpleItemBrowser_main__4TbUN","itemList":"BaseSimpleItemBrowser_itemList__Mpno4"};